<script lang="ts" setup>
  import { type PropType } from 'vue';
  import type { Breadcrumb, Section, Module, Brand } from '@storefront/types';

  defineProps({
    breadcrumbs: { type: Array as PropType<Breadcrumb[]>, required: true },
    sections: { type: Array as PropType<Section[]>, required: true },
    price: { type: Object, required: true },
    attributes: { type: Object, required: true },
    module: { type: Object as PropType<Module>, required: true },
    category: { type: Object, required: false },
    brands: { type: Array as PropType<Brand[]>, required: true },
    search: { type: String, required: false },
    options: { type: Object, required: true },
    categories: { type: Object, required: true },
    products: { type: Object, required: true },
    showMode: { type: String as PropType<'CATEGORIES' | 'PRODUCTS'>, required: true },
    available: { type: Boolean, required: true },
    availableIn: { type: Array as PropType<number[]>, required: true },
    promotionsOnly: { type: Boolean, required: true },
  });
</script>
<template>
  <main id="main">
    <div class="container">
      <template v-if="showMode === 'PRODUCTS'">
        <SfSkipToContentButton href="#products">
          {{ $t('SHOP.PRODUCT.ACTION.SKIP_TO_PRODUCTS') }}
        </SfSkipToContentButton>
        <SfSkipToContentButton href="#filters">
          {{ $t('SHOP.PRODUCT.ACTION.SKIP_TO_FILTERS') }}
        </SfSkipToContentButton>
        <SfSkipToContentButton href="#products-view-option">
          {{ $t('SHOP.PRODUCT.ACTION.SKIP_TO_DISPLAY_OPTIONS') }}
        </SfSkipToContentButton>
      </template>
      <SfBreadcrumbs :breadcrumbs />
    </div>
    <div class="container container-shop">
      <div class="description-top">
        <ShopProductsHeading :category="category" :module="module" :search="search" :total="products.total" />
      </div>
      <div v-if="sections.filter((s: any) => s.placement === 'top').length > 0" class="section-top">
        <SectionRenderer :sections="sections" placement="top" />
      </div>
      <ShopProductsGridProducts v-if="showMode === 'PRODUCTS'" v-bind="$props" />
      <ShopProductsGridCategories v-else v-bind="$props" />
      <div class="section-bottom">
        <SectionRenderer :sections="sections" placement="bottom" />
      </div>
    </div>
  </main>

  <RouterView />
</template>
<style lang="scss" scoped>
  main {
    margin-bottom: 60px;
  }

  .section-top,
  .section-bottom {
    width: 100%;
  }

  .container-shop {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--gap-default);
  }

  .description-top {
    padding: 0.5rem 0;

    p {
      padding-bottom: 1rem;
    }
  }

  @media (max-width: 992px) {

    main {
      margin-bottom: 30px;
    }

    .description {
      margin-top: 20px;
      padding: 10px;

      h1 {
        font-size: 28px;
      }
    }

    .description-top {
      padding: 0 0.625rem;
      margin-top: 0;
    }
  }
</style>
